import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import "./AudioPlayer.css"; // Import the audio player styles
import App from './App';
import { UserProvider } from './User';

// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

const root = createRoot(document.getElementById('root'));
window.pendingAudiobook = null;
root.render(
    //<React.StrictMode>
        <BrowserRouter>
            <UserProvider>
                <App />
            </UserProvider>
        </BrowserRouter>
    //</React.StrictMode>
);
